import store from '@/store'
import ReportInfo from './ReportInfo';
import {CREATE_UNIT_TEST} from '@/store/APIs/restapi.js'

const addToTerminal=function(text, type){
  store.commit('ADD_MESSAGE_TERMINAL_SECTION', {
    type:type,
    text:text
  })
}

export default {
  async createUnitTest(parent, testName){
    if(store.getters.getCurrentReportViewer === null || typeof(store.getters.getCurrentReportViewer.id) === 'undefined'){
      addToTerminal('Please open a report before executing this command', 'ERROR')
      return
    }
    const report = store.getters.getCurrentReportViewer
    const studies = ReportInfo.getStudiesReport(report)
    if(typeof(studies)==='undefined'){
      addToTerminal('The report does not contain valid studies', 'ERROR')
      return
    }
    for (let j = 0; j < studies.length; j++) {
      const typeCard = studies[j];
      const nameFormatted = `${testName}_${typeCard}`
      const data = {testName:nameFormatted}
      const responseBackEnd = await ReportInfo.getPlotsFromBackEnd(parent, report, typeCard, CREATE_UNIT_TEST, data)
      const message = responseBackEnd.success ? `Unit test '${nameFormatted}' created` : `Unit test '${nameFormatted}' failed`
      addToTerminal(message, 'INFO')
    }
    addToTerminal('Done. verify your API environment with the new test', 'INFO')
  }
}
